import { usePageSeo } from "@/hooks/usePageSeo";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/common/PageHero";
import { PartnerForm } from "@/components/forms/PartnerForm";
import { ShieldCheck, TrendingUp, Handshake } from "lucide-react";

const BENEFITS_EN = [
  { icon: Handshake, t: "Simple onboarding", d: "A streamlined application and dedicated support from day one." },
  { icon: TrendingUp, t: "Transparent reporting", d: "Track referrals and qualifying activity with clear reporting." },
  { icon: ShieldCheck, t: "Responsible approach", d: "We uphold regulatory-conscious, risk-aware messaging." },
];
const BENEFITS_AR = [
  { icon: Handshake, t: "انضمام سلس", d: "طلب مبسّط ودعم مخصص من اليوم الأول." },
  { icon: TrendingUp, t: "تقارير شفافة", d: "تتبّع الإحالات والنشاط المؤهل بتقارير واضحة." },
  { icon: ShieldCheck, t: "نهج مسؤول", d: "نلتزم برسائل واعية بالمخاطر ومراعية للأنظمة." },
];

export default function BecomePartner() {
  const { L, isAr } = useLang();
  const P = L.pages.become;
  usePageSeo("become");
  const benefits = isAr ? BENEFITS_AR : BENEFITS_EN;
  return (
    <>
      <PageHero
        overline={P.overline}
        title={P.title}
        description={P.desc}
        breadcrumbs={[{ label: L.common.home, to: "/" }, { label: L.nav.partners, to: "/partners" }, { label: P.overline }]}
      />

      <section className="py-16 lg:py-24">
        <div className="container-tight grid gap-10 lg:grid-cols-[1fr_1.4fr]">
          <div className="space-y-6">
            {benefits.map((i) => (
              <div key={i.t} className="flex gap-4 rounded-xl border border-hair bg-white p-5 shadow-sm">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-canvas text-finblue"><i.icon className="h-5 w-5" strokeWidth={1.5} /></span>
                <div><h3 className="font-heading font-semibold text-ink">{i.t}</h3><p className="mt-1 text-sm text-subtle">{i.d}</p></div>
              </div>
            ))}
          </div>
          <PartnerForm />
        </div>
      </section>
    </>
  );
}
